import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'
import academicLevelTypes from 'helpers/enums/academicLevelTypes'
import userAcademicLevel from 'redux/selectors/user/academic_level_selector'

const getLibraries = state => state.libraries
const getUser = state => state.user

const searchToolbarSelector = createSelector(
	[getLibraries, getUser, userAcademicLevel],
	(libraries, user, userAcademicLevel) => {
		let library
		if (user.extra && user.extra.libraries) {
			const libraryUID = libraries.current.libraryUID
			library = user.extra.libraries.find(element => element.id===libraryUID)
		}
		const library_type = library ? library.library_type: ''
		let library_type_name = ''
		const type = library ? library.type: ''
		switch (type) {
			case 'PD':
				library_type_name = 'Nearpod Learning Labs'
				break
			case 'ELL':
				library_type_name = 'Nearpod EL'
				break
			case 'Common Sense Education':
				library_type_name = 'Common Sense Portuguese'
				break
			case 'DCL':
				library_type_name = 'Digital Citizenship & Literacy'
				break
			case 'CCE':
				library_type_name = 'College & Career Exploration'
				break
			case 'WLE':
				library_type_name = 'World Languages en Español'
				break
			case 'HPL':
				library_type_name = 'Historical Perspectives & Literacy'
				break
			case 'SEL':
				library_type_name = 'Social & Emotional Learning'
				break
			case 'NPF':
				library_type_name = 'Flocabulary Video Pack'
				break
			case 'PrivateLibrary':
			default:
				switch (library_type) {
					case 'school':
						library_type_name = localize('teacher_private_library_search_toolbar_title_library')
						break
					case 'district':
						library_type_name = localize('teacher_private_library_search_toolbar_title_district')
						break
				}
		}
		const isHigherEdUser = userAcademicLevel === academicLevelTypes.HIGHER_ED
		const shouldShowFilterButton = user.fullDataLoaded && !isHigherEdUser

		return {
			filter_definitions: libraries.filter_definitions,
			selected_filters: libraries.current.search.component.selected_filters,
			applied_filters: libraries.current.search.query.applied_filters,
			applied_keyword: libraries.current.search.query.applied_keyword,
			input_value: libraries.current.search.component.input_keyword,
			filters_modal_open: libraries.current.search.component.open,
			school_name: libraries.current.settings.name,
			focusInput: libraries.current.search.focus,
			library_type_name,
			library_UID: libraries.current.libraryUID,
			type,
			hasParentFolder: libraries.current.parents && libraries.current.parents.length>0,
			canAddSubfolder: libraries.current.parents && libraries.current.parents.length<4,
			shouldShowFilterButton,
		}
	}
)

export default searchToolbarSelector
